import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useEffect, useRef } from 'react';
import { EmailContentDefinition, InAppContentDefinition } from 'modules/graphql';
import { useTemplateQueryContext } from 'modules/templateEditor/context/TemplateQueryContext';
import { useQueryParamContext } from 'modules/templateEditor/context/QueryParamContext';
import { useSaveTemplate } from '../useSaveTemplate';

export const useInitialDragAndDropLoad = <
  T extends EmailContentDefinition | InAppContentDefinition,
>() => {
  const { view } = useQueryParamContext();
  const { silentlySaveTemplate } = useSaveTemplate();
  const { liveTemplate, contentEditor } = useEditableFieldsContext();
  const { template } = useTemplateQueryContext();
  const data = (liveTemplate?.mediumData || {}) as T;

  const htmlCheck = (html: string) => {
    if (!html) {
      silentlySaveTemplate();
    }
  };

  const onEditorLoad = useRef<() => void>(() => {
    htmlCheck(data?.html || '');
  });

  useEffect(() => {
    onEditorLoad.current = () => {
      htmlCheck(data?.html);
    };
  }, [template, view, contentEditor]);

  return onEditorLoad;
};
